
























































































































































































































































import { faBan, faStar, faSync } from '@fortawesome/free-solid-svg-icons'
import { mapGetters } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import PromoButton from '~/components/car/classifieds/promote/PromoButton.vue'
import { capitalizeString } from '~/utils/string'
import { formatNumber } from '~/utils/number'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { ciCredit } from '~/icons/source/solid/credit'
import { APP_NS } from '~/store/modules/shared/app/state'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { PromoButton },
  props: {
    selectedTier: {
      type: Object,
      required: false,
      default: null
    },
    classified: { type: Object, required: true },
    actionPending: { type: Boolean, default: false },
    maxRefreshCount: { type: Number, default: 6 },
    preferredPayment: { type: String, default: 'credits' }
  },
  data() {
    return {
      refreshClickedCount: 0
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      paidCredits: 'paidCredits',
      isAdmin: 'isAdmin'
    }),
    ...mapGetters(APP_NS, {
      isPlot: 'isPlot',
      isCar: 'isCar'
    }),
    icons() {
      return {
        star: faStar,
        credits: ciCredit,
        refresh: faSync,
        ban: faBan
      }
    },
    disableRefresh() {
      return this.refreshClickedCount >= this.maxRefreshCount
    },
    paidCreditsFormatted() {
      if (this.paidCredits || this.paidCredits === 0) {
        return formatNumber(this.paidCredits)
      }
      return null
    },
    creditsLeftFormatted() {
      if (this.paidCredits) {
        return formatNumber(this.paidCredits - this.selectedTier.cost)
      }
      return null
    },
    buyCreditsUrl() {
      const legacyUrlService = this.$dep(LegacyUrlService)
      return legacyUrlService.getBuyCreditsUrl()
    }
  },
  methods: {
    refreshClicked() {
      this.$emit('refresh')

      // lets prevent some request spam
      this.refreshClickedCount++
      if (this.refreshClickedCount >= this.maxRefreshCount) {
        setTimeout(() => {
          // give another try after 1 minute
          this.refreshClickedCount = this.maxRefreshCount - 1
        }, 60000)
      }
    },
    getTitleForTier(tier: string) {
      // for now just capitalize
      return capitalizeString(tier)
    }
  }
})
